<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">
  
    <div class="w-full p-2 flex-1">
      <div class="flex justify-center gap-2">
        <button (click)="onCancel()"
          class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">Retour</button>
      </div>

      <div class="flex justify-center gap-4 items-center m-4">
        <button mat-mini-fab color="primary" (click)="decreasePaidAmount()" [disabled]="freeAmount <= 0">
          <mat-icon>remove</mat-icon>
        </button>

        <!-- Saisie directe -->

        <input type="number" step="0.01" min="0.00" [max]="data.totalAmount" [(ngModel)]="freeAmount"
          [ngClass]="cssService.tipInputNumber" (ngModelChange)="onFreeAmountChange()" placeholder="0.00"><span
          class="text-gray-500">{{data.currencyFormat.currencySymbol}}</span>

        <button mat-mini-fab color="primary" (click)="increasePaidAmount()" [disabled]="freeAmount >= data.totalAmount">
          <mat-icon>add</mat-icon>
        </button>
      </div>


      <div class="flex justify-center gap-2">
        <button *ngIf="!isFreeAmountValid()"
          [ngClass]="cssService.cancelButtonClass + 'opacitiy-50 cursor-not-allowed'">1
          euro minimum, merci.</button>
        <button *ngIf="isFreeAmountValid()" (click)="onConfirm()"
          class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full">Valider</button>
      </div>
    </div>
</app-dialog-wrapper>
